// extracted by mini-css-extract-plugin
module.exports = {"small":"FavoriteButtonSmall_small__8LMYj","active":"FavoriteButtonSmall_active__f_O6H"};